module.exports = __webpack_public_path__ + "img/quilt-rank-count-bg.f96606cf.png";